




import { Vue, Component, Prop } from 'vue-property-decorator';
import { Chart } from 'highcharts-vue';
import moment from 'moment';

@Component({
  components: {
    highcharts: Chart,
  },
})
export default class DownlineChart extends Vue {
  @Prop() readonly series: any;

  @Prop() readonly title!: string;

  chartOptions: any = {
    tooltip: {
      useHTML: true,
      headerFormat: '',
      pointFormat: '<span style="color:{point.color}">●</span><b>{point.name} <b><br>{point.y:,.0f}',
    },
    chart: {
      type: 'pie',
    },
    title: {
      text: this.title,
    },
    subtitle: {
      text: `In ${moment().format('MMM, YYYY')}`,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.amountCurrency:,.2f} <br>USDT</br>: {point.y:,.2f} ',
        },
      },
    },
  };

  created() {
    const { series } = this;
    this.chartOptions = { ...this.chartOptions, series };
  }
}
